export function wishlistFunctionsPDP() {
  let wishlistButtonAdd = document.querySelector(".wishlist-btn-add-pdp");
  let wishlistButtonRemove = document.querySelector(".wishlist-btn-remove-pdp");

  function swymCallbackFn() {
    if (wishlistButtonAdd || wishlistButtonRemove) {
      _swat.fetchWrtEventTypeET(fetchCallbackFn, 4);
      // fetching all wishlist events
    }
  }

  function fetchCallbackFn(products) {
    let activeProductId = Number(wishlistButtonAdd.getAttribute("data-product-id"));
    let activeVariantId = Number(wishlistButtonAdd.getAttribute("data-variant-id"));
    let activeProductUrl = `${window.location.origin}${wishlistButtonAdd.getAttribute("data-product-url")}`;
    let isInWishlist = products.find(function (p) {
      return p.empi == activeProductId && p.epi == activeVariantId;
    });
    if (isInWishlist) {
      wishlistButtonRemove.classList.add("show");
      wishlistButtonAdd.classList.add("hide");
    } else {
      wishlistButtonRemove.classList.remove("show");
      wishlistButtonAdd.classList.add("show");
    }

    SwymPageData.et = 4;
    SwymPageData.du = activeProductUrl;
    SwymPageData.epi = activeVariantId;
    SwymPageData.empi = activeProductId;
    wishlistButtonAdd.addEventListener("click", function (e) {
      if (SwymPageData) {
        _swat.addToWishList(SwymPageData, function (e) {
          wishlistButtonAdd.classList.remove("show");
          wishlistButtonAdd.classList.add("hide");
          wishlistButtonRemove.classList.remove("hide");
          wishlistButtonRemove.classList.add("show");
        });
      }
    });

    wishlistButtonRemove.addEventListener("click", function (e) {
      if (SwymPageData) {
        _swat.removeFromWishList(SwymPageData, function (e) {
          wishlistButtonRemove.classList.remove("show");
          wishlistButtonRemove.classList.remove("hide");
          wishlistButtonAdd.classList.remove("hide");
          wishlistButtonAdd.classList.add("show");
        });
      }
    });
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);
}


